import axios from "axios";
import Cookies from "js-cookie";
const { createAsyncThunk } = require("@reduxjs/toolkit");

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const insertQuickreply = createAsyncThunk(
  "quickreply/insertQuickreply",
  async (values, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/quickreply/insert`,
        values,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      return response.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || "An error occurred");
    }
  }
);
export const getQuickreplyAllData = createAsyncThunk(
  "quickreply/getQuickreplyAllData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/quickreply/get`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      console.log(response.data.data, "responseresponseresponse");
      return response.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || "An error occurred");
    }
  }
);

export const deleteQuickreply = createAsyncThunk(
  "quickreply/deletetQuickreply",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/quickreply/delete/${id}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      console.log(response.data.data, "responseresponseresponse");
      return response.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || "An error occurred");
    }
  }
);
